import React from 'react';
import styles from './formsBrowser.module.scss';
import { getRecentForms } from './services/formsBrowserService';
import { Form } from './Form';
import { useTranslation } from 'react-i18next';
import {
    FormProps,
    LocalStorageProps,
    SelectionProps,
} from './types/FormTypes';

export const RecentForms = React.memo(
    (props: {
        selectionProps: SelectionProps;
        localStorageProps: LocalStorageProps;
    }) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps,
                selectionProps: { allForms },
                localStorageProps: { recentFormIds, removeRecentFormId },
            } = props;

            if (recentFormIds?.length) {
                return (
                    <>
                        <div className={styles.formsGalleryViewContainer}>
                            <div
                                className={styles.formsGalleryViewSubContainer}
                            >
                                {getRecentForms(
                                    recentFormIds,
                                    allForms,
                                    removeRecentFormId,
                                )?.map((form: FormProps, index) => (
                                    <div key={index}>
                                        <Form
                                            form={form}
                                            selectionProps={selectionProps}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                );
            } else {
                return <div>{t('FormsBrowser.RecentlyViewedDescription')}</div>;
            }
        } catch {
            return null;
        }
    },
);
